export const testLib = [
  {
    name: "jest",
    experience: "4 years",
    rate: 5,
  },
  {
    name: "enzyme",
    experience: "4 years",
    rate: 5,
  },
  {
    name: "react-testing-lib",
    experience: "3 years",
    rate: 4,
  },
];
